var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2746 11.8336C14.4132 11.8336 15.3361 12.7565 15.3361 13.8951V14.4225C15.3361 15.2423 15.0432 16.0351 14.5101 16.6578C13.0715 18.3385 10.8832 19.1679 8.00004 19.1679C5.1163 19.1679 2.92912 18.3383 1.49335 16.6568C0.961889 16.0345 0.669922 15.243 0.669922 14.4246V13.8951C0.669922 12.7565 1.59287 11.8336 2.73139 11.8336H13.2746ZM13.2746 13.2086H2.73139C2.35226 13.2086 2.04492 13.516 2.04492 13.8951V14.4246C2.04492 14.9156 2.22011 15.3905 2.53897 15.7639C3.68784 17.1093 5.48989 17.7929 8.00004 17.7929C10.5101 17.7929 12.3138 17.1093 13.4655 15.7637C13.7854 15.39 13.9611 14.9143 13.9611 14.4225V13.8951C13.9611 13.516 13.6538 13.2086 13.2746 13.2086ZM8.00004 0.837891C10.5313 0.837891 12.5834 2.88992 12.5834 5.42122C12.5834 7.95253 10.5313 10.0046 8.00004 10.0046C5.4687 10.0046 3.41667 7.95253 3.41667 5.42122C3.41667 2.88992 5.4687 0.837891 8.00004 0.837891ZM8.00004 2.21289C6.22812 2.21289 4.79167 3.64932 4.79167 5.42122C4.79167 7.19314 6.22812 8.62958 8.00004 8.62958C9.77195 8.62958 11.2084 7.19314 11.2084 5.42122C11.2084 3.64932 9.77195 2.21289 8.00004 2.21289Z",
    fill: "url(#paint0_linear_1816_1657)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1816_1657",
    x1: 0.669922,
    y1: 11.1485,
    x2: 15.3361,
    y2: 11.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.327f0654b39e8c19e70af9250cfda65c.svg";
export { ForwardRef as ReactComponent };